var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-functions'),_vm._v(" "),_c('div',{staticClass:"welcome"},[_c('br'),_vm._v(" "),_c('h1',{staticClass:"title"},[_vm._v("Twoja idealna dieta na wyciągnięcie ręki")]),_vm._v(" "),_c('p',{staticClass:"title"},[_vm._v("Dodaj produkt i rozpocznij tworzenie dziennika")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/chooseFood","exact":""}},[_c('i',{staticClass:"fas fa-cart-plus"})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53b884d3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Start.vue
// module id = 122
// module chunks = 0